import { render, staticRenderFns } from "./ListadoSiniestros.vue?vue&type=template&id=47caeb2d&"
import script from "./ListadoSiniestros.vue?vue&type=script&lang=js&"
export * from "./ListadoSiniestros.vue?vue&type=script&lang=js&"
import style0 from "./ListadoSiniestros.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports